import { on } from 'delegated-events';
import createFocusTrap from 'focus-trap';
import helpers from './helpers.js';
import locationSelectorPopulating from './location-selector-populating.js';

export default (function () {
  let locationSelector;
  let httpRequest;
  return {
    init() {
      locationSelector = document.querySelector('.js-location-selector');

      if (locationSelector == null) return;

      on('click', '.js-launch-location', (e) => {
        e.preventDefault();
        e.currentTarget.blur();
        try {
          const apiURL = e.currentTarget.dataset.api || document.querySelector('.js-launch-location[data-api]').dataset.api || false;
          if (apiURL) {
            this.requestLocations(apiURL);
            this.open();
          }
        } catch (error) {
          console.error('Cannot determine API URL');
        }
      });

      // Create the focus trap
      locationSelector.setAttribute('tabindex', '-1');
      this.locationFocusTrap = createFocusTrap(locationSelector, {
        fallbackFocus: locationSelector,
      });

      on('click', '.js-location-close', (e) => {
        e.preventDefault();
        this.close();
      });

      on('click', '.js-region-redirect', (e) => {
        e.preventDefault();
        const path = e.currentTarget.getAttribute('data-path');
        const apiURL = e.currentTarget.dataset.api || document.querySelector('.js-launch-location[data-api]').dataset.api;
        const callback = () => {
          this.rewriteLinks(path);
          this.open();
        };
        if (apiURL) {
          this.requestLocations(apiURL, callback);
        }
      });

      on('click', '.js-close-location-bar', (e) => {
        const bar = document.querySelector('.location-bar');
        bar.classList.add('u-hide');
      });
    },
    open() {
      document.documentElement.classList.add('is-location-open');

      this.locationFocusTrap.activate();

      if (helpers.breakpoint() === 'mobile') {
        const bar = document.querySelector('.location-bar');
        if (bar != null) bar.classList.add('u-hide');
      }
      window.setTimeout(() => {
        document.querySelector('.location-selector .js-location-close').focus();
      }, 300);
    },
    close() {
      // js-closest-office
      document.documentElement.classList.remove('is-location-open');

      // deactivate the focus trap
      this.locationFocusTrap.deactivate();

      const open = locationSelector.querySelectorAll('.js-expand-link.is-open');
      const openTarg = locationSelector.querySelectorAll('.js-expand-target.is-shown');

      if (open.length) {
        helpers.addClass(openTarg, 'is-hidden u-hide');
        helpers.removeClass(openTarg, 'is-shown');
        helpers.removeClass(open, 'is-open');
        helpers.addClass(open, 'is-closed');
      }
      this.resetLinks();
    },
    requestLocations(apiURL, callback) {
      httpRequest = new XMLHttpRequest();
      if (!httpRequest) {
        console.log('Giving up :( Cannot create an XMLHTTP instance');
      } else {
        httpRequest.onreadystatechange = () => {
          this.processRequestedLocations(callback);
        };
        httpRequest.open('GET', apiURL);
        httpRequest.send();
      }
    },
    processRequestedLocations(callback) {
      if (httpRequest.readyState !== XMLHttpRequest.DONE || httpRequest.status !== 200) {
        // console.log('There was a problem with the request.');
      } else {
        const responseText = JSON.parse(httpRequest.responseText);
        const closeBtnElm = document.querySelector('.location-selector__close');
        const locationSelectorElm = document.querySelector('.location-selector__inr');
        const opcoAlertCloseBtnElm = document.querySelector('.opco-alert__close');
        const opcoAlertContentElm = document.querySelector('.opco-alert__content');

        if (closeBtnElm) {
          closeBtnElm.innerHTML = responseText.CloseButtonLabel;
        }
        if (locationSelectorElm) {
          locationSelectorPopulating.format(locationSelectorElm, responseText);
        }
        if (opcoAlertCloseBtnElm) {
          opcoAlertCloseBtnElm.innerHTML = responseText.CloseButtonLabel;
        }
        if (opcoAlertContentElm) {
          opcoAlertContentElm.innerHTML = `<h2 class="display-heading opco-alert__title">${responseText.PopupTitle} <br> <span class="opco-alert__name js-opco-alert-name"></span></h2>
          <p>${responseText.PopupDescription} <span class="js-opco-alert-name"></span></p>
          <p>
            <a class="btn btn--small js-opco-alert-proceed" href="#"><span class="btn__text">${responseText.PopupContinue}</span></a>
          </p>`;
        }

        if (typeof callback === 'function') {
          callback();
        }
      }
    },
    rewriteLinks(path) {
      const links = locationSelector.querySelectorAll('[data-href]');
      if (links != null) {
        [...links].forEach((link) => {
          if (link.href && link.href.indexOf('?') > -1) {
            link.href += `&${path}`;
          } else {
            link.href += `?${path}`;
          }
        });
      }
    },
    resetLinks() {
      const links = locationSelector.querySelectorAll('[data-href]');
      if (links != null) {
        [...links].forEach((link) => {
          link.href = link.getAttribute('data-href');
        });
      }
    },
  };
}());
